function LoaderSpin({ show = true, width = 5, height = 5, wrapperClass = 'bg-white', spinClass = 'border-t-tertiary' }) {
  return (
    show && (
      <div className={`absolute top-0 left-0 w-full h-full flex items-center justify-center z-20 ${wrapperClass}`}>
        <div className={`relative w-${width} h-${height}`}>
          <div className={`absolute top-0 left-0 w-full h-full animate-spin rounded-full border-2 border-grey-800 ${spinClass}`}></div>
        </div>
      </div>
    )
  )
}

export default LoaderSpin
